import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import { ctxTachograph } from '@/contexts/TachographCtx';
import TachographGenerateButton from './TachographGenerateButton';
import { TachoTabs } from './TachographPopup';
import TachographDriverData from './TachographDriverData';
import TachographFileNameSelector from './TachographFileNameSelector';

export default function TachographDriverTab({ activeTab }: { activeTab: TachoTabs }) {
  const { t } = useTranslation();
  const tachographCtx = useContext(ctxTachograph);

  if (!tachographCtx) return null;

  return (
    <>
      <div id="target-tachograph-data" data-qa-element-id="driver_selector_panel">
        <Typography variant="h6" id="report-header-h3" data-qa-element-id="driver_selector_panel_title">
          {t('tachograph.driverSelector')}
        </Typography>
        <TachographDriverData isListView={false} />
        {tachographCtx.selectedRowCardNumbers.length > 0 && (
          <div id="target-tachograph-data-menu" data-qa-element-id="file_download_panel">
            <div className="tachograph-radio-button-conainer">
              <TachographFileNameSelector />
            </div>
            <div className="tachograph-button-conainer">
              <TachographGenerateButton activeTab={activeTab} />
              <Typography
                variant="helperText"
                className="tachograph-generate-comment"
                data-qa-element-id="file_download_helper_text"
              >
                {t('tachograph.downloadButton.description')}
              </Typography>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
